import React from 'react'

export type Icon = React.ReactNode

export enum Variant {
  TRANSPARENT,
  WHITE,
  BLUE,
  BLACK,
  STROKED
}

export enum Size {
  LARGE,
  MEDIUM,
  SMALL
}

/** @NOTE Этот enum определяет ширину кнопки.
 *  - NARROW: соответствует узкой кнопке (ширина: fit-content).
 *  - WIDE: соответствует широкой кнопке (ширина: auto).
 *
 *  В макете был такой вариант (Wide)
 */

export enum Width {
  NARROW = 'NARROW',
  WIDE = 'WIDE',
  SUBMIT = 'SUBMIT'
}

export type Props = {
  size?: Size
  variant?: Variant
  width?: Width
  isLoading?: boolean
} & React.ButtonHTMLAttributes<HTMLButtonElement>

export type StaticProps = {
  Size: typeof Size
  Variant: typeof Variant
  Width: typeof Width
}
